<template>
  <table>
    <caption>반복맞춤소식 대상자별</caption>
    <thead>
      <tr>
          <th>번호</th>
          <th>소식종류</th>
          <th>소식내용</th>
          <th>작성자</th>
          <th>유효기간</th>
          <th>예약시간</th>
          <th>전송주기</th>
        </tr>
    </thead>
    <tbody>
      <tr v-for="rowData in sourceList">
        <td>{{rowData.id}}</td>
        <td>{{getNewsTypeCombineText(rowData.newsType, rowData.customNewsType)}}
        <td>{{rowData.boardContent}}</td>
        <td>{{rowData.userName}}</td>
        <td>{{$utils.datePeriodText(rowData.validFrom, rowData.validTo)}}</td>
        <td>{{rowData.reserveTime.slice(0, 5)}}</td>
        <td>{{getRepeatStrategyText(rowData.repeatStrategy)}}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import newsMixin from "$views/News/_mixin";
export default {
  mixins: [newsMixin],
  props: {
    sourceList: Array
  }
};
</script>

<style>
</style>